








































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import "@pan-gms/vuetify-jsonschema-form/dist/main.css";
import "vuetify/dist/vuetify.min.css";

const namespace: string = "migration";

@Component({
  components: {
    VJsonschemaForm,
  },
})
export default class ForecastComponent extends Vue {
  @Prop() schema: any;
  @Prop() model: any;
  @Prop() forecastData: any;
  @Prop() formOptions: any;
  @Prop() validations: any;

  formValid: boolean = false;
  schemaformKey: number = 0;

  get subSchema() {
    if (this.schema && this.schema.forecastTemplate) {
      return this.schema.forecastTemplate;
    }
  }

  get dataModel() {
    if (!this.model.forecast) {
      this.model.forecast = this.forecastData.forecast;
    }

    return this.model.forecast;
  }

  @Watch("model")
  onDataChanged(value: any, oldValue: any) {
    this.schemaformKey += 1;
  }
}
